<template>
  <div class="topicZX" v-bind:style="this.bgStyle">
    <!--<div class="w w1200">-->
      <!--<el-breadcrumb class="breakcrumbHeader" separator-class="el-icon-arrow-right">-->
        <!--<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
        <!--<el-breadcrumb-item>{{ topicInfo.pageTitle }}</el-breadcrumb-item>-->
      <!--</el-breadcrumb>-->
    <!--</div>-->
    <div v-for="bXyWapHome in pageSetting" :key="bXyWapHome.id">

      <!-- 轮播图start -->
      <el-carousel class="carouselBox" trigger="click" height="500px" v-if="bXyWapHome.ascription == 1">
        <el-carousel-item v-for="(item, index) in bXyWapHome.column" :key="index">
          <router-link  :to="`${item.url}`">
            <el-image :src="`${item.picimg}`" fit="fill" style="width: 100%; height: 500px" >
              <div slot="error" class="image-slot">/[];;
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </router-link>
        </el-carousel-item>
      </el-carousel>
      <!-- 轮播图end -->

      <!-- 通知轮播start -->
      <div class="shop_new" v-if="bXyWapHome.ascription == 13">
        <div class="sy_c">
          <div class="sy_gg">
            <div class="shop_new_logo">
              <img th:src="@{/portal/images/new1.png}" />
              <div class="shop_new_text">最新公告</div>
            </div>
            <div class="ranklist">
              <el-carousel direction="vertical" :interval="2000" class="notice_div" indicator-position="none">
                <el-carousel-item v-for="item in notice_list" :key="item">
                  <router-link :to="`siteHelpDetail?itemId=${item.articleId}`" :underline="false"
                               :title="item.articleTitle">{{ item.articleTitle }}</router-link>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="new_more">
              <el-button @click="$router.push('/siteHelp?articleId=2&categoryId=8')" type="danger" icon="el-icon-more"
                         size="small" title="更多"></el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 通知轮播 end -->

      <!--  一行三个图片 模板1105 开始 -->
      <div class="wrap1 floor_blank clearfix" v-if="bXyWapHome.ascription == 2">
        <div class="block onethreeImg1">
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <img alt="广告位置1" :src="bXyWapHome.column[0].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 1" :to="`${bXyWapHome.column[1].url}`">
            <img alt="广告位置2" :src="bXyWapHome.column[1].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 2" :to="`${bXyWapHome.column[2].url}`">
            <img alt="广告位置3" :src="bXyWapHome.column[2].picimg" style="display: inline" />
          </router-link>
        </div>
      </div>
      <!--  一行三个图片 结束 -->

      <!--  广告图 开始 -->
      <div class="wrap1 clearfix" v-if="bXyWapHome.ascription == 12">
        <div class="block el-image">
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <img alt="广告位置1" :src="bXyWapHome.column[0].picimg" style="display: inline" />
          </router-link>
        </div>
      </div>
      <!--  广告图 结束 -->

      <!--  一行三个图片 模板1111开始 -->
      <div class="wrap1 floor_blank clearfix" v-if="bXyWapHome.ascription == 8">
        <div class="block onethreeImg2">
          <router-link v-if="bXyWapHome.column.length > 0" :to="`${bXyWapHome.column[0].url}`">
            <img alt="广告位置1" :src="bXyWapHome.column[0].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 1" :to="`${bXyWapHome.column[1].url}`">
            <img alt="广告位置2" :src="bXyWapHome.column[1].picimg" style="display: inline" />
          </router-link>
          <router-link v-if="bXyWapHome.column.length > 2" :to="`${bXyWapHome.column[2].url}`">
            <img alt="广告位置3" :src="bXyWapHome.column[2].picimg" style="display: inline" />
          </router-link>
        </div>
      </div>
      <!--  一行三个图片 结束 -->

      <!-- 模板1 start 美丽人生--模板1110-->
      <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 7">
        <h4 class="floor_title" v-if="bXyWapHome.column[0].name">
          <a href="javascript:;">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : ''}}</a>
        </h4>
        <div class="floor_hotcat" v-if="bXyWapHome.column[1].name || bXyWapHome.column[2].name">
          <router-link v-if="bXyWapHome.column[1].name" :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{
            bXyWapHome.column[1].name!=null?bXyWapHome.column[1].name:''
            }}</router-link>
          <router-link v-if="bXyWapHome.column[2].name" :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
            {{bXyWapHome.column[2].name != null ? bXyWapHome.column[2].name:""}}
          </router-link>
        </div>
        <div class="floor_content">
          <div class="floor_banner_second">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <!-- :onerror="defaultImg" -->
              <img alt="广告图片"
                   :src="bXyWapHome.column[3].picimg!=null?bXyWapHome.column[3].picimg:''" style="display: inline" />
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img alt="广告图片"
                   :src="bXyWapHome.column[4].picimg!=null?bXyWapHome.column[4].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''"><img alt="广告图片"
                                                                                               :src="bXyWapHome.column[5].picimg!=null?bXyWapHome.column[5].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''"><img alt="广告图片"
                                                                                               :src="bXyWapHome.column[6].picimg!=null?bXyWapHome.column[6].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="last_item" :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''"><img alt="广告图片"
                                                                                                                 :src="bXyWapHome.column[7].picimg!=null?bXyWapHome.column[7].picimg:''" style="display: inline" />
            </router-link>
            <router-link :to="bXyWapHome.column[8].url!=null?bXyWapHome.column[8].url:''"><img alt="广告图片"
                                                                                               :src="bXyWapHome.column[8].picimg!=null?bXyWapHome.column[8].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="max_goods" :to="bXyWapHome.column[9].url!=null?bXyWapHome.column[9].url:''"><img alt="广告图片"
                                                                                                                 :src="bXyWapHome.column[9].picimg!=null?bXyWapHome.column[9].picimg:''" style="display: inline" />
            </router-link>
            <router-link class="last_item" :to="bXyWapHome.column[10].url!=null?bXyWapHome.column[10].url:''">
              <img alt="广告图片" :src="bXyWapHome.column[10].picimg!=null?bXyWapHome.column[10].picimg:''"
                   style="display: inline" />
            </router-link>
          </div>
        </div>
      </div>
      <!-- 模板1108 -->
      <div class="wrap1 floor_style_first clearfix" v-if="bXyWapHome.ascription == 5">
        <div class="mt fn-clear" v-if="bXyWapHome.column[0].name || bXyWapHome.column[1].name">
          <div class="floor_title">
            <router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : ''}}</router-link>
          </div>
          <div class="floor_hotcat">
            <a href="">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : ''}}</a>
          </div>
        </div>
        <div class="mc fn-clear">
          <div class="floor_content">
            <div class="floor_banner">
              <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
                <img
                  alt="广告图片" :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''"
                  style="display: inline-block;">
              </router-link>
            </div>
            <div class="floor_goods">
              <div class="block">
                <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''"><img
                  alt="广告图片"
                  :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg : ''"
                  style="display: inline-block;"></router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''"><img
                  alt="广告图片"
                  :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg : ''"
                  style="display: inline-block;"></router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''"><img
                  alt="广告图片"
                  :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg : ''"
                  style="display: inline-block;"></router-link>
              </div>
            </div>
            <div class="floor_cat">
              <div class="block">
                <router-link :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[8].url!=null?bXyWapHome.column[8].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[8].picimg!=null? bXyWapHome.column[8].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[9].url!=null?bXyWapHome.column[9].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[9].picimg!=null? bXyWapHome.column[9].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
              <div class="block">
                <router-link :to="bXyWapHome.column[10].url!=null?bXyWapHome.column[10].url:''">
                  <img
                    alt="广告图片"
                    :src="bXyWapHome.column[10].picimg!=null? bXyWapHome.column[10].picimg : ''"
                    style="display: inline-block;">
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 楼层模板1112 -->
      <div class="wrap1 floor_style_third clearfix" v-if="bXyWapHome.ascription == 9">
        <h4 class="floor_title" v-if="bXyWapHome.column[0].name"><router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : ''}} </router-link></h4>
        <div class="floor_hotcat" v-if="bXyWapHome.column[1].name">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : ''}}</router-link>
        </div>
        <div class="floor_content">
          <div class="floor_banner_third">
            <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
              <img alt="广告图片"
                   :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''">
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <img
                alt="广告图片1112"
                :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg:''">
            </router-link>
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg:''">
            </router-link>
            <router-link  class="last_item" :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg:''">
            </router-link>
            <router-link   :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg:''">
            </router-link>
            <router-link  class="last_item max_goods" :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg:''">
            </router-link>
          </div>
        </div>
      </div>
      <!-- 楼层1113 -->
      <div class="wrap1 floor_style_fourth clearfix" v-if="bXyWapHome.ascription == 10">
        <h4 class="floor_title" v-if="bXyWapHome.column[0].name"><router-link :to="bXyWapHome.column[0].url!=null?bXyWapHome.column[0].url:''">{{ bXyWapHome.column[0].name!=null? bXyWapHome.column[0].name : ''}}</router-link></h4>
        <div class="floor_hotcat" v-if="bXyWapHome.column[1].name">
          <router-link :to="bXyWapHome.column[1].url!=null?bXyWapHome.column[1].url:''">{{ bXyWapHome.column[1].name!=null? bXyWapHome.column[1].name : ''}}</router-link>
        </div>
        <div class="floor_content">
          <div class="banner1">
            <router-link :to="bXyWapHome.column[2].url!=null?bXyWapHome.column[2].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[2].picimg!=null? bXyWapHome.column[2].picimg : ''"
                style="display: inline;">
            </router-link>
          </div>
          <div class="banner2">
            <router-link :to="bXyWapHome.column[3].url!=null?bXyWapHome.column[3].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[3].picimg!=null? bXyWapHome.column[3].picimg : ''">
            </router-link>
          </div>
          <div class="floor_goods">
            <router-link :to="bXyWapHome.column[4].url!=null?bXyWapHome.column[4].url:''">
              <img
                alt="广告图片"
                :src="bXyWapHome.column[4].picimg!=null? bXyWapHome.column[4].picimg : ''">
            </router-link>
            <router-link :to="bXyWapHome.column[5].url!=null?bXyWapHome.column[5].url:''">
              <div class="last_item" ><img
                alt="广告图片"
                :src="bXyWapHome.column[5].picimg!=null? bXyWapHome.column[5].picimg : ''"></div>
            </router-link>
            <router-link :to="bXyWapHome.column[6].url!=null?bXyWapHome.column[6].url:''"><img
              alt="广告图片"
              :src="bXyWapHome.column[6].picimg!=null? bXyWapHome.column[6].picimg : ''">
            </router-link>
            <router-link :to="bXyWapHome.column[7].url!=null?bXyWapHome.column[7].url:''">
              <div class="last_item"><img
                alt="广告图片"
                :src="bXyWapHome.column[7].picimg!=null? bXyWapHome.column[7].picimg : ''"></div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 楼层1114 -->
      <div class="wrap1 floor_style_second clearfix" v-if="bXyWapHome.ascription == 11">
        <el-row :gutter="12">
          <el-col :span="4"  v-for="(item, index) in bXyWapHome.column" :key="index" style="width:19.8%">
            <router-link :to="item.url!=null?item.url:''">
              <div class="grid-content-1114 bg-purple">
                <div class="goods_pic_1114">
                  <el-image :src="item.picimg" class="bg">
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
              </div>
            </router-link>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  getTopciPage
} from "../../api/xunyou";
export default {
  name: 'topicZX',
  data() {
    return {
      pageSetting: [],
      topicInfo: {},
      bgStyle: {
        backgroundColor: '#f6f7f7',
        backgroundImage: ''
      }
    }
  },
  computed: {
    pageCode () {
      return this.$route.query.pageCode || '';
    },
  },
  created() {
    this.loadPage();
  },
  methods: {
    navigateTo(id) {
      if (id > 22) {
        this.$router.push(`/goodsdetail?id=${id}`);
      }
    },
    loadPage() {
        console.log("加载页面：",this.pageCode);
        getTopciPage({
          pageCode: this.pageCode
        })
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.topicInfo = res.data.page;
            this.pageSetting = res.data.pageSetting;

            if(this.topicInfo.bgColor){
              this.bgStyle.backgroundColor = this.topicInfo.bgColor;
            }
            if(this.topicInfo.bgImg){
              this.bgStyle.backgroundImage = this.topicInfo.bgImg;
            }
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.topicZX-content{
  padding-bottom: 120px;
  min-width: 1200px;
  background-color: #39864C;
}
.banner{
  width: 100%;
  height: auto;
}
.section{
  text-align: center;
  color: #FFFFFF;
  font-size: 29px;
  width: 985px;
  margin: 0 auto;
  .section-title{
    width: auto;
    height: 70px;
    margin-top: 58px;
    margin-bottom: 40px;
  }
  .good-grid{
    font-size: 0;
    .good-item{
      display: inline-block;
      width: 322px;
      height: 405px;
      margin-right: 9px;
      margin-bottom: 9px;
      padding: 8px 8px 0 8px;
      font-size: 29px;
      text-align: left;
      line-height: 1;
      background-color: rgba(37, 111, 74, 1);
      border: 2px solid #FFECA8;
      box-sizing: border-box;
      cursor: pointer;
      &:nth-child(3n+3) {
        margin-right: 0;
      }
      .img-wrap{
        position: relative;
        background-color: #fff;
        margin-bottom: 15px;
        width: 302px;
        height: 296px;
        /deep/ .el-image{
          width: 100%;
          height: 100%;
        }
        .badge{
          position: absolute;
          width: 55px;
          height: 55px;
          background: url("../../assets/img/topicZX/badge.png") no-repeat center center;
          background-size: contain;
          &.topLeft{
            top: -1px;
            left: -1px;
          }
          &.topRight{
            top: -1px;
            right: -1px;
            transform: rotateZ(90deg);
          }
          &.bottomLeft{
            bottom: -1px;
            left: -1px;
            transform: rotateZ(-90deg);
          }
          &.bottomRight{
            bottom: -1px;
            right: -1px;
            transform: rotateZ(180deg);
          }
        }
      }
      .good-price{
        font-size: 25px;
        margin-top: 5px;
        .price{
          float: left;
          display: inline-block;
          span{
            font-size: 33px;
          }
        }
        .btn{
          float: right;
          display: inline-block;
          width: 81px;
          height: 29px;
          line-height: 29px;
          text-align: center;
          background: linear-gradient(0deg, #FFDA79, #FFF0C8);
          border-radius: 7px;
          font-size: 17px;
          color: #39864C;
        }
      }
    }
  }
  .good-card{
    margin-top: 73px;
    width: 100%;
    font-size: 0;
    background-color: rgba(37, 111, 74, 1);
    border: 2px solid #FFECA8;
    .entry{
      float: left;
      width: 249px;
      height: 100%;
      cursor: pointer;
    }
    .good-card-grid{
      font-size: 0;
      padding-top: 35px;
      box-sizing: border-box;
      .good-item{
        display: inline-block;
        width: 213px;
        height: 273px;
        font-size: 22px;
        color: #DF3F38;
        text-align: left;
        margin-right: 20px;
        margin-bottom: 20px;
        border-radius: 6px;
        overflow: hidden;
        background-color: #fff;
        cursor: pointer;
        &:nth-child(3n+3){
          margin-right: 0;
        }
        &:nth-child(n+4){
          margin-bottom: 0;
        }
        .img-wrap{
          width: 213px;
          height: 206px;
          /deep/ .el-image{
            width: 100%;
            height: 100%;
          }
        }
        .good-info{
          padding: 10px 5px;
          line-height: 1;
          box-sizing: border-box;
          background: linear-gradient(4deg, rgba(254, 247, 229, 0.96), rgba(255, 237, 190, 0.96));
          .good-name{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-bottom: 5px;
          }
          .label{
            font-size: 17px;
          }
        }
      }
    }
  }
  .good-list{
    font-size: 0;
    .good-item{
      display: inline-block;
      width: 315px;
      height: 376px;
      margin-right: 20px;
      margin-bottom: 30px;
      font-size: 29px;
      text-align: left;
      line-height: 1;
      background-color: rgba(37, 111, 74, 1);
      border: 2px solid #FFECA8;
      box-sizing: border-box;
      border-radius: 12px;
      cursor: pointer;
      overflow: hidden;
      &:nth-child(3n+3) {
        margin-right: 0;
      }
      .img-wrap{
        position: relative;
        background-color: #fff;
        margin-bottom: 15px;
        height: 275px;
        border: 2px solid #FFECA8;
        border-radius: 0 0 12px 12px;
        /deep/ .el-image{
          width: 100%;
          height: 100%;
        }
      }
      .good-info{
        padding: 0 10px;
        color: #FFECA8;
        .good-price{
          font-size: 25px;
          margin-top: 5px;
          .price{
            float: left;
            display: inline-block;
            span{
              font-size: 33px;
            }
          }
          .btn{
            float: right;
            display: inline-block;
            width: 81px;
            height: 29px;
            line-height: 29px;
            text-align: center;
            background: linear-gradient(0deg, #FFDA79, #FFF0C8);
            border-radius: 7px;
            font-size: 17px;
            color: #39864C;
          }
        }
      }
    }
  }
}


/* 首页COPP样式  开始************************ end*/


//秒杀
  .skill_act_pic {
    width: -webkit-fill-available;
    height: 177px;
    overflow: hidden;
    padding: 28px;
  }

.skill_act_name {
  width: 166px;
  line-height: 30px;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 10px 28px;
}

.skill_act_price {
  width: 165px;
  height: 30px;
  margin: 10px 28px;
}

.skill_act_price .act_now_price {
  display: inline-block;
  width: 80px;
  text-align: center;
  color: #fff;
  line-height: 28px;
  height: 28px;
  border: 1px solid #c11045;
  background: #c11045;
}

.skill_act_price .act_old_price {
  display: inline-block;
  width: 80px;
  text-align: center;
  line-height: 28px;
  height: 28px;
  background: #fff;
  text-decoration: line-through;
  border: 1px solid #c11045;
  color: #8f8f8f;
}

//平团
  .grid-content-spell {
    border-radius: 4px;
    min-height: 423px;
  }

.spell_goods_pic {
  width: -webkit-fill-available;
  height: 200px;
  overflow: hidden;
  padding: 28px;
}

.act_info {
  width: 100%;
  height: 60px;
  background: #c11045;
// padding: 10px 0px;
  padding: 10px 10px;
  box-sizing: border-box;
  color: #FFF;
  position: relative;
  font-size: 12px;
  line-height: 18px;
}

.act_info span {
  display: inline-block;
  width: 18px;
  height: 18px;
  text-align: center;
  background: #FFF;
  border-radius: 5px;
  color: #c11045;
  line-height: 18px;
}

.act_info p {
  margin-bottom: 2px;
}

.act_info .buy_cart {
  position: absolute;
  width: 120px;
  height: 30px;
  right: 0px;
  top: 0px;
  background: url(../../assets/images/buy_cart.png);
  top: 15px;
}

.pname {
  width: 100%;
  height: 55px;
  margin-top: 10px;
  position: relative;
}

.pname .name {
  width: 185px;
  margin: 15px;
  height: 40px;
  line-height: 20px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  text-align: left;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #333;
}

.pname .price {
  position: absolute;
  right: 15px;
  top: 10px;
  font-size: 18px;
  line-height: 28px;
  height: 28px;
  color: #c11045;
  font-weight: bold;
}

.percentBar {
  width: 250px;
  margin: 0px 15px;
}

.percentBar .barWrap {
  width: 100%;
  height: 8px;
  border: 6px;
  border: 1px solid #ffa9c3;
  border-radius: 8px;
  position: relative;
}

.percentBar .barWrap b {
  display: inline-block;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background-color: #ffa9c3;
}

b,
strong {
  font-weight: 700 !important;
}

//楼层模板1114
  .grid-content-1114 {
    border-radius: 4px;
    min-height: 460px;
  }

.goods_pic_1114 {
  width: -webkit-fill-available;
  height: 460px;
  overflow: hidden;
}

//公用
  /deep/.el-image div.image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #d3dce638;
    color: #909399;
    font-size: 40px;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
  }

.bg {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

//提示框
  /deep/.el-notification.right {
    right: 55px;
  }

/deep/.el-notification {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 96%;
  padding: 14px 26px 14px 13px;
  border-radius: 8px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #EBEEF5;
  position: fixed;
  background-color: #FFF;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  -webkit-transition: opacity .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
  transition: opacity .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
  transition: opacity .3s, transform .3s, left .3s, right .3s, top .4s, bottom .3s;
  transition: opacity .3s, transform .3s, left .3s, right .3s, top .4s, bottom .3s, -webkit-transform .3s;
  overflow: hidden;
}

// .left_bar {
   //     width: 230px;
   //     height: 336px;
   //     background-image: url(../images/index/skill.png);
   //     float: left;
   //     margin-right: 2px;
   //     position: relative;
   // }

.carouselBox.el-carousel.el-carousel--horizontal {
  width: calc(100% - 40px);
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.bg-purple {
// background: #d3dce638;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
}

.grid-content {
  border-radius: 4px;
  min-height: 330px;
}

.el-col-5 {
  width: 20%;
}

/* 热门分类 start*/
.column-title {
  text-align: center;
  color: #fff;
  min-height: 82px;
  overflow: hidden;
}

.channel-column {
  width: 230px;
  height: 330px;
  float: left;
  margin-right: 10px;
  position: relative;
  z-index: 1;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}

.column-img {
  width: 155px;
  height: 155px;
  margin: 20px auto 0;
}

.column-btn {
  display: block;
  width: 140px;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  text-align: center;
  border-radius: 20px;
  background-color: #fff;
  position: absolute;
  bottom: 17px;
  left: 46px;
  -webkit-transition: all 150ms ease-in-out;
  transition: all 150ms ease-in-out;
}

/* 热门分类 end*/
/* 公告通知 start */
.notice_div {
  height: 100%;
  line-height: 50px;
  font-size: 16px;
}

/deep/.notice_div .el-carousel__container {
  height: 100%;
}

/* 公告通知 end */

</style>



// WEBPACK FOOTER //
// src/views/topicPages/topicIndex.vue